import {OrganizationActions, OrganizationActionTypes} from '../actions/organization.actions';
import {Organization} from '../models/organization';
import {ErrorPayload} from '../models/general';

export interface State {
  entities: { [id: string]: Organization };
  self: Organization | null;
  isGetOrganizationsLoading: boolean;
  isGetOrganizationsLoaded: boolean;
  getOrganizationsError: string | null;
  isPostOrganizationLoading: boolean;
  isPostOrganizationLoaded: boolean;
  postOrganizationError: string | null;
  isGetSelfOrganizationLoading: boolean;
  isGetSelfOrganizationLoaded: boolean;
  getSelfOrganizationError: string | null;
}

export const initialState: State = {
  entities: {},
  self: null,
  isGetOrganizationsLoading: false,
  isGetOrganizationsLoaded: false,
  getOrganizationsError: null,
  isPostOrganizationLoading: false,
  isPostOrganizationLoaded: false,
  postOrganizationError: null,
  isGetSelfOrganizationLoading: false,
  isGetSelfOrganizationLoaded: false,
  getSelfOrganizationError: null
};

export function reducer(state = initialState, action: OrganizationActions): State {
  switch (action.type) {

    case OrganizationActionTypes.GetOrganizations: {
      return {
        ...state,
        isGetOrganizationsLoading: true,
        isGetOrganizationsLoaded: false,
        getOrganizationsError: null
      };
    }

    case OrganizationActionTypes.GetOrganizationsComplete: {
      const organizations: Organization[] = action.payload;
      const entities: { [id: string]: Organization } = organizations.reduce(
        (acc: { [id: string]: Organization }, organization: Organization) => {
          return {
            ...acc,
            [organization.id]: organization
          }
        }, {});

      return {
        ...state,
        entities,
        isGetOrganizationsLoading: false,
        isGetOrganizationsLoaded: true
      };
    }

    case OrganizationActionTypes.GetOrganizationsError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isGetOrganizationsLoading: false,
        getOrganizationsError: errorPayload.errorMessage
      };
    }

    case OrganizationActionTypes.PostOrganization: {
      return {
        ...state,
        isPostOrganizationLoading: true,
        isPostOrganizationLoaded: false,
        postOrganizationError: null
      };
    }

    case OrganizationActionTypes.PostOrganizationComplete: {
      return {
        ...state,
        isPostOrganizationLoading: false,
        isPostOrganizationLoaded: true
      };
    }

    case OrganizationActionTypes.PostOrganizationError: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        isPostOrganizationLoading: false,
        postOrganizationError: errorPayload.errorMessage
      };
    }

    case OrganizationActionTypes.GetSelfOrganization: {
      return {
        ...state,
        isGetSelfOrganizationLoading: true,
        isGetSelfOrganizationLoaded: false,
        getSelfOrganizationError: null
      };
    }

    case OrganizationActionTypes.GetSelfOrganizationComplete: {
      const self: Organization = action.payload;
      return {
        ...state,
        self,
        isGetSelfOrganizationLoading: false,
        isGetSelfOrganizationLoaded: true
      };
    }

    case OrganizationActionTypes.GetSelfOrganizationError: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        isGetSelfOrganizationLoading: false,
        getSelfOrganizationError: errorPayload.errorMessage
      };
    }

    default:
      return state;
  }
}

export const organizationEntities = (state: State) => state.entities;
export const selfOrganization = (state: State) => state.self;
export const isGetOrganizationsLoading = (state: State) => state.isGetOrganizationsLoading;
export const isGetOrganizationsLoaded = (state: State) => state.isGetOrganizationsLoaded;
export const getOrganizationsError = (state: State) => state.getOrganizationsError;
export const isPostOrganizationLoading = (state: State) => state.isPostOrganizationLoading;
export const isPostOrganizationLoaded = (state: State) => state.isPostOrganizationLoaded;
export const postOrganizationError = (state: State) => state.postOrganizationError;
export const isGetSelfOrganizationLoading = (state: State) => state.isGetSelfOrganizationLoading;
export const isGetSelfOrganizationLoaded = (state: State) => state.isGetSelfOrganizationLoaded;
export const getSelfOrganizationError = (state: State) => state.getSelfOrganizationError;
